module.exports = __webpack_public_path__ + "static/media/FT-Fondo-Prototipos.c790c4db.jpg";